import { Component, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { EditPermissions, NodeBuilder, NodeFlowDetails } from '../../../../../../../shared/models';
import { SetVariableFormType, SetVariableNode } from './variable';
import { swalMini } from '../../../../../../../shared/utils/utils';
import { newStepValue } from "../../../../../services/flowBuilder/utils/constants";

const NODE_TYPE = 'setVariable';

@Component({
  selector: 'app-variable-node',
  templateUrl: './variable-node.component.html',
  styleUrls: ['./variable-node.component.scss']
})
export class VariableNodeComponent extends NodeBuilder implements OnInit {

    // Data From DELEGATOR
    nodeFlowDetails: NodeFlowDetails;
    canEdit: EditPermissions;

    // FormGroups
    actionParams: FormGroup = undefined;
    actionVariables: FormGroup = undefined;
    stepUniqueID: string = '';

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  get getStepData(): {} {
    const actionParams = this.actionParams.getRawValue();
    const actionVariables: any = this.actionVariables.getRawValue();

    const setVariableNode = new SetVariableNode(this.nodeType);

    setVariableNode.addActionParams(actionParams);
    setVariableNode.addVariables(actionVariables.variables);
    setVariableNode.addResult(actionParams.success);
    let nodeData = setVariableNode.nodeData;
    return nodeData;
  }

  get isNodeValid(): boolean {
    this.actionParams.markAllAsTouched();
    this.actionVariables.markAllAsTouched();

    return this.actionParams.valid && this.actionVariables.valid;
  }
  set buildForm(stepData: any) {
    const formData: SetVariableFormType = SetVariableNode.toForm(stepData);
    if (!stepData) {
      return;
    }
    this.buildActionParamsForm(formData);
    this.buildVariablesForm(formData);

    // Patch variable success value for new step
    if (this.actionParams.get('success').value === newStepValue) {
      this.actionParams.get('success').setValue('step' + this.getNextStep());
    }
  }

  buildActionParamsForm(formData) {
    this.actionParams = SetVariableNode.getActionTemplate(this.canEdit);
    this.actionParams.patchValue(formData.actionParams);
  }

  buildVariablesForm(formData) {
    this.actionVariables = new FormGroup({
      variables: new FormArray([]),
    });
    const variables = this.actionVariables.controls.variables as FormArray;

    if (formData.actionVariables.length < 1) {
      variables.push(SetVariableNode.getVariablesTemplate(this.canEdit));
    }
    for (const variable of formData.actionVariables) {
      variables.push(SetVariableNode.getVariablesTemplate(this.canEdit));
    }
    variables.patchValue(formData.actionVariables);
  }

  onAddVariable(form): void {
    form.push(SetVariableNode.getVariablesTemplate(this.canEdit));
  }

  onDeleteVariable(index, form, disabled) {
    if (form.length === 1 && !disabled) {
      swalMini({title: 'At least one option needed', type: 'error'});
      return;
    }
    if (!this.canEdit.canEdit) {
        return;
    }
    form.removeAt(index);
  }

}
